import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Compose tailwind classnames with conflict resolution. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
